export const SELECT = "bitte wählen";
export const BTN_PHOTO = "FOTO ÄNDERN";
export const MATERIAL = "Material";
export const BEFUND = "Befund";
export const FREE_TEXT = "Freitext";